import { EdgeFunctionError } from '@/lib/supabase-utils';

/**
 * The edge functions' canonical org-membership rejection wording, emitted with
 * HTTP 403 by `_shared/members/{verification,permissions}.ts` and deliberately
 * kept to one shape for client-side matching (see
 * `email-list/lib/request-handler.ts`). Retrying cannot succeed — the server's
 * membership view is authoritative.
 */
const MEMBERSHIP_REJECTION_PATTERN = /\bnot a member of (?:this|the requested) organization\b/;

/**
 * True when the error is an edge function's org-membership 403. Callers should
 * respond by re-checking memberships (see `useMembershipRecheck`), not by
 * retrying the rejected query. Errors that lost their status in transport
 * (plain `Error` rethrows, `EdgeFunctionError` without a status) match on the
 * canonical wording alone.
 */
export function isMembershipRejectionError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }
  if (error instanceof EdgeFunctionError && error.status !== undefined && error.status !== 403) {
    return false;
  }
  return MEMBERSHIP_REJECTION_PATTERN.test(error.message);
}
